import React, { FC } from "react";
import progressBar from "../assets/images/ncdc/progressbar.svg";

const NcdcRequestInfoBox: FC = () => {
    return (
        <div className={'ncdc-request-info-box-wrapper'}>
            <img src={progressBar} />
        </div>
    );
}

export default NcdcRequestInfoBox;
